<template>
    <div class="user">
      <router-view/>
    </div>
</template>

<script>

    export default {
        name: "User",
        data(){
          return {

          }
        }
    }
</script>

<style lang="scss" scoped>
.user{

}
</style>
